import api from "./api.service";
import { store } from "@/store/store";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

function getDeviceId() {
  const deviceInfo = store.getters.getDeviceInfo;
  return deviceInfo.hasInfo ? deviceInfo.device_id : 0;
}

export default class extends api {
  static myContracts() {
    return this.apiRequest(
      API_SUFFIX +
        `/api/license/MyContracts/${getDeviceId()}/${
          store.getters.getDeviceInfo.product
        }`,
      {},
      "GET"
    );
  }

  static myLicense() {
    return this.apiRequest(
      `${API_SUFFIX}/api/licensev2/MyLicense/${getDeviceId()}/${
        store.getters.getDeviceInfo.product
      }`,
      {},
      "GET"
    );
  }

  static myV2Licenses() {
    return this.apiRequest(
      `${API_SUFFIX}/api/licensev2/MyLicenses/realiti`,
      {},
      "GET"
    );
  }

  static claimLicense(contractId, kitColour, deviceSerial) {
    return this.apiRequest(
      API_SUFFIX + "/api/license/ClaimLicense",
      {
        ContractId: contractId,
        DeviceId: getDeviceId(),
        KitColour: kitColour,
        DeviceSerialNumber: deviceSerial,
      },
      "POST"
    );
  }
  
  static claimLicenseV2(licenseUuid, kitColour, deviceSerial, label) {
    return this.apiRequest(
      API_SUFFIX + "/api/licensev2/ActivateLicense",
      {
        uuid_id: licenseUuid,
        device_id: getDeviceId(),
        license_colour: kitColour,
        device_serial: deviceSerial,
        description: label,
      },
      "POST"
    );
  }

  static relinquishLicense(license) {
    if (license.is_v2) {
      return this.apiRequest(API_SUFFIX + "/api/licensev2/DeactivateLicense", {
        license_id: license.uuid_id,
        device_id: getDeviceId(),
      });
    } else {
      return this.apiRequest(
        API_SUFFIX + "/api/license/RelinquishLicense",
        {
          license_id: license.id,
          device_id: getDeviceId(),
        },
        "DELETE"
      );
    }
  }
}
